export const ROUTE_SITECORE_JSS = 'all'
